module.exports = __webpack_public_path__ + "static/media/pile.a4b873fc.png";